/**
 * SchoolMapBody
 * 
 * @Author: Focci
 * @Date: 2023-08-08 15:01:41
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-08 15:01:41
 */

'use client'

import PropTypes from 'prop-types'
import { useMemo } from 'react'
import Mapbox, { Popup, Marker } from '@comp/mapbox'
import FullscreenController from '@comp/mapbox/controller/FullscreenController'
import NavigationController from '@comp/mapbox/controller/NavigationController'
import MarkerController from '@comp/mapbox/controller/panel/MarkerController'
import { SchoolInfoBody } from '@comp/mapbox/SchoolInfo'
import SchoolMapBusStops from './SchoolMapBusStops'

export default function SchoolMapBody({ data = {}, ...props }) {
  const defaultValue = useMemo(() => ({
    longitude: data.lng,
    latitude: data.lat,
    zoom: data?.has_school_network > 0 ? 13 : 11
  }), [data])

  return (
    <Mapbox initialViewState={defaultValue}>
      {/* Panel */}
      <div className="absolute z-[9] right-4 top-4">
        <MarkerController />
      </div>
      {/* 放大、缩小、卫星图 */}
      <div className="absolute z-10 bottom-4 right-4">
        <div className="flex flex-col items-start gap-2">
          <NavigationController small vertical />
          <FullscreenController small />
        </div>
      </div>
      <Marker disabledMarker={defaultValue} />
      <Popup />
      <SchoolInfoBody data={data} {...props} />
      <SchoolMapBusStops data={data} />
    </Mapbox>
  )
}

SchoolMapBody.propTypes = {
  data: PropTypes.object,
}
